<app-input-wrapper
  [label]="label"
  [label2]="label2"
  [labelOnPress]="labelOnPress"
  [valueLabel]="valueLabel"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [alt]="alt"
  [onPress]="onPress"
  [disabled]="disabled ?? false"
  [readonly]="readonly ?? false"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
>

  <!-- PrimeNG Calendar for Date and Time Selection -->
  <p-calendar
    [(ngModel)]="value"
    [showTime]="showTime ?? false"
    [hourFormat]="'24'"
    [dateFormat]="dateFormat"
    [placeholder]="placeholder"
    [disabled]="disabled ?? false"
    [readonlyInput]="readonly ?? false"
    [showIcon]="showIcon ?? false"
    (onSelect)="handleDateChange($event)">
  </p-calendar>

</app-input-wrapper>
